export const LABORATORY_UNDEFINED = "Not assigned";

export const TEST_REQUEST_STATE_DISPLAY_NAMES_MAPPING = {
  CANCELED: "Canceled",
  COMPLETED: "Completed",
  DECLINED: "Declined",
  DELETED: "Deleted",
  DRAFT: "Draft",
  FOR_APPROVAL: "For Approval",
  FOR_EVALUATION: "For Evaluation",
  FOR_REVIEW: "For Review",
  IN_EXECUTION: "In Execution",
  IN_PREPARATION: "In Preparation",
  REPORT_CREATION: "Report Creation",
  SUBMITTED: "Submitted",
  __NONE: "",
} as const;
